import { render, staticRenderFns } from "./AppSign.vue?vue&type=template&id=1b0ebb81&scoped=true&"
var script = {}
import style0 from "./AppSign.vue?vue&type=style&index=0&id=1b0ebb81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ebb81",
  null
  
)

export default component.exports